import React from 'react';
import { setup, styled } from './goober.js';
setup(React.createElement);
export default styled;
